import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

interface ItfItem {
    title: string;
    desc: string;
    img: [string, string];
}
const Tab3: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            title: t('E_item3_list1_title'),
            desc: t('E_item3_list1_desc'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783933146281-c4tdln-compressed-%E4%BD%8E%E6%B8%A9.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783933288222-ymdn0w-compressed-Frame%202094656015.jpg',
            ],
        },
        {
            title: t('E_item3_list2_title'),
            desc: t('E_item3_list2_desc'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783933154722-kr07xm-compressed-Frame%202094654971.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783933292706-j9debz-compressed-Frame%202094656014.jpg',
            ],
        },
        {
            title: t('E_item3_list3_title'),
            desc: t('E_item3_list3_desc'),
            img: [
                'https://websiteoss.ecoflow.com/figma-uploads/1783933161779-9s5jwv-compressed-%E9%AB%98%E6%B8%A9.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1783933299660-g1rlm4-compressed-Frame%202094656013.jpg',
            ],
        },
    ];
    return (
        <ul className={`${css.frag}`}>
            {items?.map((item: ItfItem) => (
                <li className="item" key={item.title}>
                    <EcoImg className="item-img" pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} alt={t('E_item3_list1_title')} />
                    <div className="item-info">
                        <p className="item-title">{item.title}</p>
                        <p className="item-desc">{item.desc}</p>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default Tab3;
